module.exports = __webpack_public_path__ + "static/media/good_course_arrows.08240153.svg";